var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntentsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.07692C4.72878 2.07692 2.07692 4.72878 2.07692 8C2.07692 11.2712 4.72878 13.9231 8 13.9231C11.2712 13.9231 13.9231 11.2712 13.9231 8C13.9231 4.72878 11.2712 2.07692 8 2.07692ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 4.94872C6.31482 4.94872 4.94872 6.31482 4.94872 8C4.94872 9.68518 6.31482 11.0513 8 11.0513C9.68518 11.0513 11.0513 9.68518 11.0513 8C11.0513 6.31482 9.68518 4.94872 8 4.94872ZM3.87179 8C3.87179 5.72006 5.72006 3.87179 8 3.87179C10.2799 3.87179 12.1282 5.72006 12.1282 8C12.1282 10.2799 10.2799 12.1282 8 12.1282C5.72006 12.1282 3.87179 10.2799 3.87179 8ZM8 7.82051C7.90087 7.82051 7.82051 7.90087 7.82051 8C7.82051 8.09913 7.90087 8.17949 8 8.17949C8.09913 8.17949 8.17949 8.09913 8.17949 8C8.17949 7.90087 8.09913 7.82051 8 7.82051ZM6.74359 8C6.74359 7.3061 7.3061 6.74359 8 6.74359C8.6939 6.74359 9.25641 7.3061 9.25641 8C9.25641 8.6939 8.6939 9.25641 8 9.25641C7.3061 9.25641 6.74359 8.6939 6.74359 8Z",
    fill: "#5E6C84",
    stroke: "#5E6C84",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntentsFilter);
export default __webpack_public_path__ + "static/media/intentsFilter.de26114c60de3b1ca8d21eae0194bed8.svg";
export { ForwardRef as ReactComponent };